import hunt from 'huntjs';

import './stats-section.scss';

const delay = 30,
    increments = 40;

class statsSection {

    constructor(el) {
        this.el = el;
        // get items
        this.items = [];
        this.el.querySelectorAll('.stats-section--item').forEach((o,i) => {
            this.items[i] = {
                el: o,
                value: parseInt(o.querySelector('.stats-section--item--number--value').innerText),
                stage: o.querySelector('.stats-section--item--number--stage')
            }
            // get increments and interval for animations
            this.items[i].increments = [];
            let inc = this.items[i].value / increments;
            for(var x = this.items[i].value; x > 0; x = x - inc) {
                this.items[i].increments.push(parseInt(x));
            }
            this.items[i].increments.push(0);
            // add hunt
            let thisInstance = this;
            this.hunt = new hunt(o, {
                enter: function () {
                    setTimeout(() => {
                        thisInstance.reveal(i);
                    },500);
                }
            });
        });
    }

    reveal(i) {
        this.items[i].el.classList.add('active');
        let counter = 0;
        for(let x = this.items[i].increments.length - 1; x >= 0; x--) {
            setTimeout(() => {
                this.items[i].stage.innerText = this.items[i].increments[x];
            }, counter * delay);
            counter ++;
        }
    }

}

// export the default function to create
export function createFrom(wrappers) {

    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new statsSection(node);
        }
    });

}